import { db } from "../../firebase";
import {
    collection, query, where, getDocs, doc, getDoc,
    updateDoc, arrayRemove, serverTimestamp, orderBy, limit
} from "firebase/firestore";

// Mark drawn/expired tickets so queues don't linger
export async function cleanupAgentQueues(agentUid) {
    if (!agentUid) return;
    const now = Date.now();

    const scan = async (status) => {
        const qs = query(collection(db, "tickets"), where("agentUid", "==", agentUid), where("status", "==", status));
        const snap = await getDocs(qs);
        for (const d of snap.docs) {
            const t = d.data();
            const cardRef = doc(db, "cards", t.cardId);
            const cardSnap = await getDoc(cardRef);
            const card = cardSnap.data();

            const expMs = t.paymentExpireAt?.toDate?.()?.getTime?.() || new Date(t.paymentExpireAt || 0).getTime();
            const isExpired = !!expMs && expMs < now;
            const cardInactive = !card || card.status !== "active";

            if (isExpired || cardInactive) {
                await updateDoc(d.ref, {
                    status: cardInactive ? "void_drawn" : "expired",
                    expiredAt: serverTimestamp(),
                });
                const nums = Array.isArray(t.numbers) ? t.numbers : [];
                if (nums.length) await updateDoc(cardRef, { locked: arrayRemove(...nums) });
            }
        }
    };

    await scan("requested");
    await scan("agent_approved");
    await scan("payment_submitted");
}

// Find the first actionable queue and return its cardId
export async function getFirstPendingCardId(agentUid) {
    const q1 = query(
        collection(db, "tickets"),
        where("agentUid", "==", agentUid),
        where("status", "==", "requested"),
        orderBy("requestedAt", "asc"),
        limit(1)
    );
    const q2 = query(
        collection(db, "tickets"),
        where("agentUid", "==", agentUid),
        where("status", "==", "payment_submitted"),
        orderBy("paymentSubmittedAt", "asc"),
        limit(1)
    );

    const [s1, s2] = await Promise.all([getDocs(q1), getDocs(q2)]);
    const pick = s1.docs[0] || s2.docs[0];
    if (!pick) return null;

    const t = pick.data();
    const cardSnap = await getDoc(doc(db, "cards", t.cardId));
    if (!cardSnap.exists() || cardSnap.data().status !== "active") return null;
    return t.cardId;
}
